<script>

import Service from '../../services/operative-plan'
import Dialog from 'primevue/dialog';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import InputNumber from 'primevue/inputnumber';
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue'
import GenericCustomAutocompleteV2 from '../../components/generic/GenericCustomAutocompleteV2.vue'
import GenericBooleanDropdown from '../generic/GenericBooleanDropdown.vue';
import LabelField from '../generic/LabelField.vue';
import Checkbox from 'primevue/checkbox';

export default{
    props: ['item', 'refreshGrid'],
    components: {
        Dialog, 
        DataTable, Column,
        InputNumber, Checkbox,
        GenericCustomAutocompleteV2, GenericBooleanDropdown,
        ResponsiveButton,
        LabelField
    },
    data(){
        return{
            recordId: null,
            newItem: {
                tank: null,
                pipeline: null,
                aspirator: null,
                pump: null,
                measurer: null,
                platform: null
            },
            visible: false,
            tanksList: [],
            pipelinesList: [],
            aspiratorsList: [],
            pumpsList: [],
            measurersList: [],
            platformsList: [],
            changesPropagate: true,
            scheduledEquipmentOperation: false,
            equipmentOperationTank: null
        }
    },
    methods: {
        show(){
            this.visible= true;
        },
        loadEquipmentLayout(id, scheduledEquipmentOperation, tank){
            this.recordId = id;

            this.scheduledEquipmentOperation = scheduledEquipmentOperation;
            if(this.scheduledEquipmentOperation){
                this.equipmentOperationTank = tank;
                // if(tankField){
                //     this.equipmentOperationTank = record[tankField];
                // }else{
                //     this.equipmentOperationTank = record.equipmentOperationTank;
                // }
            }

            this.tanksList = [];
            this.pipelinesList = [];
            this.aspiratorsList = [];
            this.pumpsList = [];
            this.measurersList = [];
            this.platforms = [];

            this.newItem = {
                tank: null,
                pipeline: null,
                aspirator: null,
                pump: null,
                measurer: null,
                platform: null
            }

            Service.getScheduledOperationEquipmentLayout(this.recordId, response => {
                if(response.success){
                    this.tanksList = response.data.tanksList;
                    this.pipelinesList = response.data.pipelinesList;
                    this.aspiratorsList = response.data.aspiratorsList;
                    this.pumpsList = response.data.pumpsList;
                    this.measurersList = response.data.measurersList;
                    this.platformsList = response.data.platformsList;
                }
            })
        },
        onDelete(data){
            this.$confirm.require({
                message: this.$t('messages.delete_message_question'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {
                    let body = {
                        id: data.id,
                        propagateOnAllLinkedOperations: this.changesPropagate
                    };
                    Service.deleteScheduledOperationEquipmentLayouItem(data.id, body,
                        response => {
                            if(response.success){
                                this.loadEquipmentLayout(this.recordId, this.scheduledEquipmentOperation, this.equipmentOperationTank);
                                this.refreshGrid(true);
                                this.$confirm.close();
                                this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.delete_message_success'), life: 3000});
                            }
                            else{
                                this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                            }
                        }
                    )
                },
                reject: () => {
                    //callback to execute when user rejects the action
                    this.$confirm.close();
                }
            });
        },
        onAdd(value){

            let d = {
                idOperation: this.recordId,
                idEquipment: value,
                isPushInLine: false,
                equipmentOrder: null,
                propagateOnAllLinkedOperations: this.changesPropagate
            }

            Service.addScheduledOperationEquipmentLayouItem(d, 
                response => {
                    if(response.success){
                        this.loadEquipmentLayout(this.recordId, this.scheduledEquipmentOperation, this.equipmentOperationTank);
                        this.refreshGrid(true);
                        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.create_message_success'), life: 3000});
                    }
                    else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                }
            )
        },
        onCellEditComplete(event) {
            let { newData } = event;
            newData.propagateOnAllLinkedOperations = this.changesPropagate;

            Service.saveScheduledOperationEquipmentLayouItem(newData, 
                response => {
                    if(response.success){
                        this.loadEquipmentLayout(this.recordId, this.scheduledEquipmentOperation, this.equipmentOperationTank);
                        this.refreshGrid(true);
                        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
                    }
                    else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                }
            )

        }
    }
}

</script>

<template>
    <main>
        <Dialog :header="$t('operativePlan.selectEquipments')" v-model:visible="visible" :style="{width: '85vw'}" :modal="true">
            <template #header>
                <h3>{{$t('operativePlan.selectEquipments')}}</h3>
                
            </template>
            <h4>
                  <label-field :value="equipmentOperationTank" :label="$t('operativePlan.originTank')" v-if="scheduledEquipmentOperation" />
                </h4>
            <div class="grid">
                <div class="col-12 lg:col-4">
                    <DataTable :reorderableColumns="true" :value="tanksList" showGridlines stripedRows class="p-datatable-sm" responsiveLayout="scroll"
                        editMode="cell" @cell-edit-complete="onCellEditComplete" >
                        <template #empty>
                            {{$t('noRecordsFound')}}
                        </template>
                        <template #header>
                            <p>{{$t('operativePlan.selectTanks')}}</p>
                            <div class="grid">
                                <div class="col-10">
                                    <GenericCustomAutocompleteV2
                                        :format="{label: 'label', value: 'value'}"
                                        name="tank-equipment"
                                        v-model="newItem.tank"
                                        :disableStore="true"
                                        :api="'masterdata/equipment-combo?type=SERB&plantId=' + item.idRegistryPlant"
                                        :class="{'p-inputtext-sm w-full': true}" />
                                    </div>
                                    <div class="col-2 ">
                                        <ResponsiveButton icon="pi pi-plus" class="grid-action-btn p-button-outlined" @click="onAdd(newItem.tank)" />
                                    </div>
                                    <div class="col-12">
                                        <Checkbox name="tanks-propagate" v-model="changesPropagate" :binary="true" />
                                        <label class="ml-2" for="tanks-propagate">{{$t('operativePlan.propagateOnAllOperations')}}</label>
                                    </div>
                                </div>
                        </template>
                        <Column :exportable="false" style="min-width:2rem" :reorderableColumn="false">
                          <template #body="slotProps">
                              <ResponsiveButton icon="pi pi-trash" class="grid-action-btn p-button-rounded p-button-outlined" @click="onDelete(slotProps.data)" />
                          </template>
                        </Column>
                        <Column field="equipmentCode" :header="$t('code')" dataType="string">
                            <template #body="element">
                              {{element.data.equipmentCode}}
                            </template>
                        </Column>
                        <Column field="isPushInLine" :header="$t('operativePlan.isPushInLine')" dataType="boolean" :sortable="true">
                            <template #body="element">
                                {{element.data.isPushInLine ? $t('yes'): $t('no')}}
                            </template>
                            <template #editor="{ data, field }">
                              <GenericBooleanDropdown
                                v-model="data[field]" 
                                class="w-full p-inputtext-sm mt-1 "
                              />
                            </template>
                        </Column>
                        <Column field="equipmentOrder" :header="$t('order')" dataType="string" :sortable="true">
                            <template #body="element">
                              {{element.data.equipmentOrder}}
                            </template>
                            <template #editor="{data, field}">
                                <InputNumber 
                                    v-model="data[field]"
                                    class="w-full p-inputtext-sm mt-1" /> 
                            </template>
                        </Column>
                    </DataTable>
                </div>
                <div class="col-12 lg:col-4">
                    <DataTable :reorderableColumns="true" :value="pipelinesList" showGridlines stripedRows  class="p-datatable-sm"  responsiveLayout="scroll"
                    editMode="cell" @cell-edit-complete="onCellEditComplete">
                        <template #empty>
                            {{$t('noRecordsFound')}}
                        </template>
                        <template #header>
                            <p>{{$t('operativePlan.selectPipelines')}}</p>
                            <div class="grid">
                                <div class="col-10">
                                    <GenericCustomAutocompleteV2
                                    :format="{label: 'label', value: 'value'}"
                                    name="pipeline-equipment"
                                    v-model="newItem.pipeline" 
                                    :disableStore="true"
                                    :api="'masterdata/equipment-combo?type=OLEO&plantId=' + item.idRegistryPlant"
                                    :class="{'p-inputtext-sm w-full': true}" />
                                    </div>
                                    <div class="col-2 ">
                                        <ResponsiveButton icon="pi pi-plus" class="grid-action-btn p-button-outlined" @click="onAdd(newItem.pipeline)" />
                                    </div>
                                    <div class="col-12">
                                        <Checkbox name="pipelines-propagate" v-model="changesPropagate" :binary="true" />
                                        <label class="ml-2" for="pipelines-propagate">{{$t('operativePlan.propagateOnAllOperations')}}</label>
                                    </div>
                            </div>
                        </template>
                        <Column :exportable="false" style="min-width:2rem" :reorderableColumn="false">
                          <template #body="slotProps">
                              <ResponsiveButton icon="pi pi-trash" class="grid-action-btn p-button-rounded p-button-outlined" @click="onDelete(slotProps.data, $event)" />
                          </template>
                        </Column>
                        <Column field="equipmentCode" :header="$t('code')" dataType="string">
                            <template #body="element">
                              {{element.data.equipmentCode}}
                            </template>
                        </Column>
                        <Column field="isPushInLine" :header="$t('operativePlan.isPushInLine')" dataType="boolean" :sortable="true">
                            <template #body="element">
                                {{element.data.isPushInLine ? $t('yes'): $t('no')}}
                            </template>
                            <template #editor="{ data, field }">
                              <GenericBooleanDropdown
                                v-model="data[field]" 
                                class="w-full p-inputtext-sm mt-1 "
                              />
                            </template>
                        </Column>
                        
                        <Column field="equipmentOrder" :header="$t('order')" dataType="string" :sortable="true">
                            <template #body="element">
                              {{element.data.equipmentOrder}}
                            </template>
                            <template #editor="{data, field}">
                                <InputNumber 
                                    v-model="data[field]"
                                    class="w-full p-inputtext-sm mt-1" /> 
                            </template>
                        </Column>
                    </DataTable>
                </div>
                <div class="col-12 lg:col-4">
                    <DataTable :reorderableColumns="true" :value="aspiratorsList" showGridlines stripedRows class="p-datatable-sm"  responsiveLayout="scroll"
                    editMode="cell" @cell-edit-complete="onCellEditComplete">
                        <template #empty>
                            {{$t('noRecordsFound')}}
                        </template>
                        <template #header>
                            <p>{{$t('operativePlan.selectAspirators')}}</p>
                            <div class="grid">
                                <div class="col-10">
                                    <GenericCustomAutocompleteV2
                                        :format="{label: 'label', value: 'value'}"
                                        name="aspirators-equipment"
                                        v-model="newItem.aspirator" 
                                        :disableStore="true"
                                        :api="'masterdata/equipment-combo?type=ASP&plantId=' + item.idRegistryPlant"
                                        :class="{'p-inputtext-sm w-full': true}" />
                                </div>
                                <div class="col-2">
                                    <ResponsiveButton icon="pi pi-plus" class="grid-action-btn p-button-outlined" @click="onAdd(newItem.aspirator)" />
                                </div>
                                <div class="col-12">
                                    <Checkbox name="aspirators-propagate" v-model="changesPropagate" :binary="true" />
                                    <label class="ml-2" for="aspirators-propagate">{{$t('operativePlan.propagateOnAllOperations')}}</label>
                                </div>
                            </div>
                        </template>
                        <Column :exportable="false" style="min-width:2rem" :reorderableColumn="false">
                          <template #body="slotProps">
                              <ResponsiveButton icon="pi pi-trash" class="grid-action-btn p-button-rounded p-button-outlined" @click="onDelete(slotProps.data, $event)" />
                          </template>
                        </Column>
                        <Column field="equipmentCode" :header="$t('code')" dataType="string">
                            <template #body="element">
                              {{element.data.equipmentCode}}
                            </template>
                        </Column>
                        <Column field="isPushInLine" :header="$t('operativePlan.isPushInLine')" dataType="boolean" :sortable="true">
                            <template #body="element">
                                {{element.data.isPushInLine ? $t('yes'): $t('no')}}
                            </template>
                            <template #editor="{ data, field }">
                              <GenericBooleanDropdown
                                v-model="data[field]" 
                                class="w-full p-inputtext-sm mt-1 "
                              />
                            </template>
                        </Column>
                        
                        <Column field="equipmentOrder" :header="$t('order')" dataType="string" :sortable="true">
                            <template #body="element">
                              {{element.data.equipmentOrder}}
                            </template>
                            <template #editor="{data, field}">
                                <InputNumber 
                                    v-model="data[field]"
                                    class="w-full p-inputtext-sm mt-1" /> 
                            </template>
                        </Column>
                    </DataTable>
                </div>
                <div class="col-12 lg:col-4">
                    <DataTable :reorderableColumns="true" :value="pumpsList" showGridlines stripedRows class="p-datatable-sm"  responsiveLayout="scroll"
                    editMode="cell" @cell-edit-complete="onCellEditComplete">
                        <template #empty>
                            {{$t('noRecordsFound')}}
                        </template>
                        <template #header>
                            <p>{{$t('operativePlan.selectPumps')}}</p>
                            <div class="grid">
                                <div class="col-10">
                                    <GenericCustomAutocompleteV2
                                        :format="{label: 'label', value: 'value'}"
                                        name="pumps-equipment"
                                        v-model="newItem.pump" 
                                        :disableStore="true"
                                        :api="'masterdata/equipment-combo?type=POMP&plantId=' + item.idRegistryPlant"
                                        :class="{'p-inputtext-sm w-full': true}" />
                                </div>
                                <div class="col-2">
                                    <ResponsiveButton icon="pi pi-plus" class="grid-action-btn p-button-outlined" @click="onAdd(newItem.pump)" />
                                </div>
                                <div class="col-12">
                                    <Checkbox name="pumps-propagate" v-model="changesPropagate" :binary="true" />
                                    <label class="ml-2" for="pumps-propagate">{{$t('operativePlan.propagateOnAllOperations')}}</label>
                                </div>
                            </div>
                        </template>
                        <Column :exportable="false" style="min-width:2rem" :reorderableColumn="false">
                          <template #body="slotProps">
                              <ResponsiveButton icon="pi pi-trash" class="grid-action-btn p-button-rounded p-button-outlined" @click="onDelete(slotProps.data, $event)" />
                          </template>
                        </Column>
                        <Column field="equipmentCode" :header="$t('code')" dataType="string">
                            <template #body="element">
                              {{element.data.equipmentCode}}
                            </template>
                        </Column>
                        <Column field="isPushInLine" :header="$t('operativePlan.isPushInLine')" dataType="boolean" :sortable="true">
                            <template #body="element">
                                {{element.data.isPushInLine ? $t('yes'): $t('no')}}
                            </template>
                            <template #editor="{ data, field }">
                              <GenericBooleanDropdown
                                v-model="data[field]" 
                                class="w-full p-inputtext-sm mt-1 "
                              />
                            </template>
                        </Column>
                        
                        <Column field="equipmentOrder" :header="$t('order')" dataType="string" :sortable="true">
                            <template #body="element">
                              {{element.data.equipmentOrder}}
                            </template>
                            <template #editor="{data, field}">
                                <InputNumber 
                                    v-model="data[field]"
                                    class="w-full p-inputtext-sm mt-1" /> 
                            </template>
                        </Column>
                    </DataTable>
                </div>
                <div class="col-12 lg:col-4">
                    <DataTable :reorderableColumns="true" :value="measurersList" showGridlines stripedRows class="p-datatable-sm"  responsiveLayout="scroll"
                    editMode="cell" @cell-edit-complete="onCellEditComplete">
                        <template #empty>
                            {{$t('noRecordsFound')}}
                        </template>
                        <template #header>
                            <p>{{$t('operativePlan.selectMeasurers')}}</p>
                            <div class="grid">
                                <div class="col-10">
                                    <GenericCustomAutocompleteV2
                                        :format="{label: 'label', value: 'value'}"
                                        name="measures-equipment"
                                        v-model="newItem.measurer" 
                                        :disableStore="true"
                                        :api="'masterdata/equipment-combo?type=MIS&plantId=' + item.idRegistryPlant"
                                        :class="{'p-inputtext-sm w-full': true}" />
                                </div>
                                <div class="col-2">
                                    <ResponsiveButton icon="pi pi-plus" class="grid-action-btn p-button-outlined" @click="onAdd(newItem.measurer)" />
                                </div>
                                <div class="col-12">
                                    <Checkbox name="measurers-propagate" v-model="changesPropagate" :binary="true" />
                                    <label class="ml-2" for="measurers-propagate">{{$t('operativePlan.propagateOnAllOperations')}}</label>
                                </div>
                            </div>
                        </template>
                        <Column :exportable="false" style="min-width:2rem" :reorderableColumn="false">
                          <template #body="slotProps">
                              <ResponsiveButton icon="pi pi-trash" class="grid-action-btn p-button-rounded p-button-outlined" @click="onDelete(slotProps.data, $event)" />
                          </template>
                        </Column>
                        <Column field="equipmentCode" :header="$t('code')" dataType="string">
                            <template #body="element">
                              {{element.data.equipmentCode}}
                            </template>
                        </Column>
                        <Column field="isPushInLine" :header="$t('operativePlan.isPushInLine')" dataType="boolean" :sortable="true">
                            <template #body="element">
                                {{element.data.isPushInLine ? $t('yes'): $t('no')}}
                            </template>
                            <template #editor="{ data, field }">
                              <GenericBooleanDropdown
                                v-model="data[field]" 
                                class="w-full p-inputtext-sm mt-1 "
                              />
                            </template>
                        </Column>
                        
                        <Column field="equipmentOrder" :header="$t('order')" dataType="string" :sortable="true">
                            <template #body="element">
                              {{element.data.equipmentOrder}}
                            </template>
                            <template #editor="{data, field}">
                                <InputNumber 
                                    v-model="data[field]"
                                    class="w-full p-inputtext-sm mt-1" /> 
                            </template>
                        </Column>
                    </DataTable>
                </div>

                
                <div class="col-12 lg:col-4" v-if="scheduledEquipmentOperation">
                    <DataTable :reorderableColumns="true" :value="platformsList" showGridlines stripedRows class="p-datatable-sm"  responsiveLayout="scroll"
                    editMode="cell" @cell-edit-complete="onCellEditComplete">
                        <template #empty>
                            {{$t('noRecordsFound')}}
                        </template>
                        <template #header>
                            <p>{{$t('operativePlan.selectPlatforms')}}</p>
                            <div class="grid">
                                <div class="col-10">
                                    <GenericCustomAutocompleteV2
                                        :format="{label: 'label', value: 'value'}"
                                        name="measures-platform"
                                        v-model="newItem.platform" 
                                        :disableStore="true"
                                        :api="'masterdata/equipment-combo?type=PTF&plantId=' + item.idRegistryPlant"
                                        :class="{'p-inputtext-sm w-full': true}" />
                                </div>
                                <div class="col-2">
                                    <ResponsiveButton icon="pi pi-plus" class="grid-action-btn p-button-outlined" @click="onAdd(newItem.platform)" />
                                </div>
                                <div class="col-12">
                                    <Checkbox name="platforms-propagate" v-model="changesPropagate" :binary="true" />
                                    <label class="ml-2" for="platforms-propagate">{{$t('operativePlan.propagateOnAllOperations')}}</label>
                                </div>
                            </div>
                        </template>
                        <Column :exportable="false" style="min-width:2rem" :reorderableColumn="false">
                          <template #body="slotProps">
                              <ResponsiveButton icon="pi pi-trash" class="grid-action-btn p-button-rounded p-button-outlined" @click="onDelete(slotProps.data, $event)" />
                          </template>
                        </Column>
                        <Column field="equipmentCode" :header="$t('code')" dataType="string">
                            <template #body="element">
                              {{element.data.equipmentCode}}
                            </template>
                        </Column>
                        <Column field="isPushInLine" :header="$t('operativePlan.isPushInLine')" dataType="boolean" :sortable="true">
                            <template #body="element">
                                {{element.data.isPushInLine ? $t('yes'): $t('no')}}
                            </template>
                            <template #editor="{ data, field }">
                              <GenericBooleanDropdown
                                v-model="data[field]" 
                                class="w-full p-inputtext-sm mt-1 "
                              />
                            </template>
                        </Column>
                        
                        <Column field="equipmentOrder" :header="$t('order')" dataType="string" :sortable="true">
                            <template #body="element">
                              {{element.data.equipmentOrder}}
                            </template>
                            <template #editor="{data, field}">
                                <InputNumber 
                                    v-model="data[field]"
                                    class="w-full p-inputtext-sm mt-1" /> 
                            </template>
                        </Column>
                    </DataTable>
                </div>
            </div>
        </Dialog>
    </main>
</template>